import { requestMethods } from '../../../../Constants/requestMethods';
import { path } from '../../Paths';
import { requestFactory } from '../../RequestFactory';
import { store } from '../../../../Store';
import { toJSON, toFormData } from '../../../../Utils';
import {
    UPLOADING_USER_AVATAR_PROCESS,
    UPLOADING_USER_AVATAR_FINISHED,
} from '../../../../Store/ActionTypes/UserActionTypes';

export const bookedUsersRequest = workoutId => {
    const url = path.create().getBookedUsers(workoutId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const forgotPassword = credentials => {
    const url = path.create().forgotPassword();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(credentials),
    };

    return requestFactory.createRequest(requestConfig);
};

export const userGetAll = (filter, offsetId) => {
    const url = path.create().getAllUsers(filter, offsetId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const userGetAllForSearch = (filter, offsetId, offsetFollowers) => {
    const url = path.create().getAllUsersForSearch(filter, offsetId, offsetFollowers);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getUserPreferences = () => {
    const url = path.create().getUserPreferences();

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const logIn = credentials => {
    const url = path.create().logIn();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(credentials),
    };

    return requestFactory.createRequest(requestConfig);
};

export const loginFacebook = social_token => {
    const url = path.create().loginFacebook();

    const prepareRequestData = { social_token: social_token.accessToken, platform: 'web' };

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(prepareRequestData),
    };

    return requestFactory.createRequest(requestConfig);
};

export const logOut = credentials => {
    const url = path.create().logOut();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        headers: {},
    };

    return requestFactory.createRequest(requestConfig);
};

export const registerGymAccount = credentials => {
    const url = path.create().registerGymAccount();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(credentials),
        onUploadProgress: progressEvent => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            store.dispatch({ type: UPLOADING_USER_AVATAR_PROCESS, payload: percentCompleted });

            if (percentCompleted === 100) {
                store.dispatch({ type: UPLOADING_USER_AVATAR_FINISHED, payload: percentCompleted });
            }
        },
    };

    return requestConfig;
};

export const resetPassword = hash => {
    const url = path.create().forgotPassword();

    const requestConfig = {
        url,
        method: requestMethods.POST,
    };

    return requestFactory.createRequest(requestConfig);
};

export const registerUserAccount = credentials => {
    const url = path.create().registerUserAccount();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toFormData(credentials),
        onUploadProgress: progressEvent => {
            var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            store.dispatch({ type: UPLOADING_USER_AVATAR_PROCESS, payload: percentCompleted });

            if (percentCompleted === 100) {
                store.dispatch({ type: UPLOADING_USER_AVATAR_FINISHED, payload: percentCompleted });
            }
        },
    };

    return requestConfig;
};

export const updatePassword = ({ password }, token) => {
    const url = path.create().setPassword(token);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON({ password }),
    };

    return requestFactory.createRequest(requestConfig);
};

export const deleteUserAccount = () => {
    const url = path.create().deleteUserAccount();

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/UserApi/userRequestConfigs.js